// Angular
import { Component } from "@angular/core";

declare const $: any;
declare interface RouteInfo {
    path: string;
    title: string;
    icon: string;
    class: string;
}
export const ROUTES: RouteInfo[] = [
    {
        path: "/management/user-accounts",
        title: "User Accounts",
        icon: "ion-ios-person",
        class: "",
    },
    {
        path: "/management/roles",
        title: "Roles",
        icon: "ion-ios-gear",
        class: "",
    },
    {
        path: "/management/casetypes",
        title: "Case Types",
        icon: "ion-ios-list",
        class: "",
    },
    {
        path: "/management/countries",
        title: "Countries",
        icon: "ion-ios-location",
        class: "",
    },
    {
        path: "/management/suppliers",
        title: "Suppliers",
        icon: "ion-ios-sunny-outline",
        class: "",
    },
    {
        path: "/management/templates-list",
        title: "Templates",
        icon: "ion-ios-sunny-outline",
        class: "",
    }
];

@Component({
    selector: "app-sidemenu",
    templateUrl: "sidemenu.component.html",
    styleUrls: ["./sidemenu.component.scss"]
})
export class SideMenuComponent {
    menuItems: any[];

    constructor() { }

    ngOnInit() {
        this.menuItems = ROUTES.filter((menuItem) => menuItem);
    }
}
